import { useQuery } from "@tanstack/react-query";
import { fetchCompanyESPMdata } from "../api/user";

export const useCompanyESPMdata = (
  companyId: string,
  minimal: boolean = false,
) =>
  useQuery<any[]>({
    queryKey: ["companyESPMdata", companyId, minimal],
    queryFn: () => fetchCompanyESPMdata(companyId, !!minimal),
    enabled: !!companyId,
  });
